import type { FaireProductEntity } from "../../entity_types/product";

export const p_6iqiil1j7w: FaireProductEntity = {
  token: "p_6iqiil1j7w",
  type: "product",
  name: "Knotty Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/28a6347a712c2e58d3e0e562f9cdfe0e3676a337466178c7bfb73600308a940f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/873f6cada169bee02fd8646fb4822a5a362426241f9db6103a4976e4d133fb39.jpeg",
    "https://cdn.faire.com/fastly/8bb31ea2bdc9e2a9fb2a4a3da998f3741e06b2acb6fb06ac4df85294da18e5fd.jpeg",
    "https://cdn.faire.com/fastly/4be0be9db54ed2ff65bb97a03a1dbb2bd894c9a4b55a91b585d4973dae5ef096.jpeg",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:21.743Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
